import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import Layout from '@/app/ui/layout/index.vue'
import { AuthModule } from './app/store/modules/auth'

Vue.use(Router)

export const routeList: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: 'Dashboard',
      icon: 'tachometer-alt',
    },
    children: [
      {
        path: 'dashboard',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/app/ui/views/Dashboard/index.vue'
          ),
        meta: {
          title: 'Dashboard',
          icon: 'tachometer-alt',
        },
      },
    ],
  },
  {
    path: '/userlist',
    component: Layout,
    meta: {
      title: 'User',
      icon: 'users',
    },
    children: [
      {
        path: 'index',
        name: 'about',
        component: () =>
          import(
            /* webpackChunkName: "userlist" */ '@/app/ui/views/User/index.vue'
          ),
        meta: {
          title: 'User',
          icon: 'users',
        },
      },
    ],
  },
  {
    path: '/notification',
    component: Layout,
    meta: {
      title: 'Notification',
      icon: 'bell',
    },
    children: [
      {
        path: 'index',
        name: 'notification',
        component: () =>
          import(
            /* webpackChunkName: "notification-menu" */ '@/app/ui/views/Notification/index.vue'
          ),
        meta: {
          title: 'Notification',
          icon: 'bell',
        },
      },
    ],
  },
  {
    path: '/material-menu',
    component: Layout,
    redirect: '/material-menu/training-materials',
    meta: {
      title: 'Material',
      icon: 'folder-open',
    },
    children: [
      {
        path: 'training-materials',
        component: () =>
          import(
            /* webpackChunkName: "training-materials" */ '@/app/ui/views/MaterialMenu/TrainingMaterials/index.vue'
          ),
        meta: {
          title: 'Training Materials',
        },
      },
      {
        path: 'standar-operational',
        component: () =>
          import(
            /* webpackChunkName: "standar-operational-menu" */ '@/app/ui/views/MaterialMenu/QuickGuide/index.vue'
          ),
        meta: {
          title: 'Standard Operational',
        },
      },
      {
        path: 'salesman-bulletin',
        component: () =>
          import(
            /* webpackChunkName: "salesman-bulletin" */ '@/app/ui/views/MaterialMenu/SalesmanBulletin/index.vue'
          ),
        meta: {
          title: 'Salesman Bulletin',
        },
      },
      {
        path: 'aditional-info',
        component: () =>
          import(
            /* webpackChunkName: "additional-info" */ '@/app/ui/views/MaterialMenu/AditionalInfo/index.vue'
          ),
        meta: {
          title: 'Additional Info',
        },
      },
    ],
  },
  {
    path: '/content-management',
    component: Layout,
    redirect: 'content-management/home-banner',
    meta: {
      title: 'Content',
      icon: 'list-alt',
    },
    children: [
      {
        path: 'home-banner',
        component: () =>
          import(
            /* webpackChunkName: "home-banner" */ '@/app/ui/views/ContentManagement/HomeBanner/index.vue'
          ),
        meta: {
          title: 'Home Banner',
        },
      },
      {
        path: 'disclaimer',
        component: () =>
          import(
            /* webpackChunkName: "disclaimer" */ '@/app/ui/views/ContentManagement/FAQ/index.vue'
          ),
        meta: {
          title: 'Frequently Ask Question',
        },
      },
      {
        path: 'recommendation',
        component: () =>
          import(
            /* webpackChunkName: "faq" */ '@/app/ui/views/ContentManagement/Recomendation/index.vue'
          ),
        meta: {
          title: 'Recommendation',
        },
      },
      {
        path: 'popup',
        component: () =>
          import(
            /* webpackChunkName: "userlist" */ '@/app/ui/views/ContentManagement/OtherContent/index.vue'
          ),
        meta: {
          title: 'Other Content',
        },
      },
    ],
  },
  {
    path: '/report',
    component: Layout,
    redirect: 'report/user-report',
    meta: {
      title: 'Report',
      icon: 'chart-bar',
    },
    children: [
      {
        path: 'user-report',
        component: () =>
          import(
            /* webpackChunkName: "user-report" */ '@/app/ui/views/Report/UserReport/index.vue'
          ),
        meta: {
          title: 'User Report',
        },
      },
      {
        path: 'training-report',
        component: () =>
          import(
            /* webpackChunkName: "training-report" */ '@/app/ui/views/Report/TrainingMaterialReport/index.vue'
          ),
        meta: {
          title: 'Training Material Report',
        },
      },
      {
        path: 'SOP-report',
        component: () =>
          import(
            /* webpackChunkName: "quick-report" */ '@/app/ui/views/Report/QuickGuideReport/index.vue'
          ),
        meta: {
          title: 'SOP Report',
        },
      },
      {
        path: 'salesman-report',
        component: () =>
          import(
            /* webpackChunkName: "salesman-report" */ '@/app/ui/views/Report/SalesmanBuletinReport/index.vue'
          ),
        meta: {
          title: 'Salesman Bulletin Report',
        },
      },
      {
        path: 'additional-info-report',
        component: () =>
          import(
            /* webpackChunkName: "additional-info-report" */ '@/app/ui/views/Report/AdditionalInfoReport/index.vue'
          ),
        meta: {
          title: 'Additional Info Report',
        },
      },
      {
        path: 'notification-report',
        component: () =>
          import(
            /* webpackChunkName: "notification-report" */ '@/app/ui/views/Report/NotificationReport/index.vue'
          ),
        meta: {
          title: 'Notification Report',
        },
      },
    ],
  },
  {
    path: '/report-admin',
    component: Layout,
    redirect: 'report-admin/user-report',
    meta: {
      title: 'Report Admin',
      icon: 'chart-bar',
    },
    children: [
      {
        path: 'user-report',
        component: () =>
          import(
            /* webpackChunkName: "user-report" */ '@/app/ui/views/Report/UserReport/index.vue'
          ),
        meta: {
          title: 'User Report',
        },
      },
      {
        path: 'training-report',
        component: () =>
          import(
            /* webpackChunkName: "training-report" */ '@/app/ui/views/Report/TrainingMaterialReport/index.vue'
          ),
        meta: {
          title: 'Training Material Report',
        },
      },
      {
        path: 'SOP-report',
        component: () =>
          import(
            /* webpackChunkName: "quick-report" */ '@/app/ui/views/Report/QuickGuideReport/index.vue'
          ),
        meta: {
          title: 'SOP Report',
        },
      },
      {
        path: 'salesman-report',
        component: () =>
          import(
            /* webpackChunkName: "salesman-report" */ '@/app/ui/views/Report/SalesmanBuletinReport/index.vue'
          ),
        meta: {
          title: 'Salesman Bulletin Report',
        },
      },
      {
        path: 'additional-info-report',
        component: () =>
          import(
            /* webpackChunkName: "additional-info-report" */ '@/app/ui/views/Report/AdditionalInfoReport/index.vue'
          ),
        meta: {
          title: 'Additional Info Report',
        },
      },
    ],
  },
  {
    path: '/master',
    component: Layout,
    redirect: '/master/master-car',
    meta: {
      title: 'Master',
      icon: 'car',
    },
    children: [
      {
        path: 'master-car',
        component: () =>
          import(
            /* webpackChunkName: "admin-setting" */ '@/app/ui/views/MasterCar/index.vue'
          ),
        meta: {
          title: 'Master Category',
        },
      },
      {
        path: 'position',
        component: () =>
          import(
            /* webpackChunkName: "admin-role-setting" */ '@/app/ui/views/Position/index.vue'
          ),
        meta: {
          title: 'Position',
        },
      },
    ],
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/index',
    meta: {
      title: 'CMS Setting',
      icon: 'users-cog',
    },
    children: [
      {
        path: 'index',
        component: () =>
          import(
            /* webpackChunkName: "admin-setting" */ '@/app/ui/views/AdminSetting/AdminCMS/index.vue'
          ),
        meta: {
          title: 'Admin CMS',
        },
      },
      {
        path: 'add-role',
        component: () =>
          import(
            /* webpackChunkName: "admin-role-setting" */ '@/app/ui/views/AdminSetting/AdminCMSRole/index.vue'
          ),
        meta: {
          title: 'Admin CMS Role',
        },
      },
    ],
  },
  {
    path: '/gallery-image',
    component: Layout,
    meta: {
      title: 'Gallery Image',
      icon: 'images',
    },
    children: [
      {
        path: 'index',
        name: 'gallery-image',
        component: () =>
          import(
            /* webpackChunkName: "master-car" */ '@/app/ui/views/Gallery/index.vue'
          ),
        meta: {
          title: 'Gallery Image',
          icon: 'images',
        },
      },
    ],
  },
  {
    path: '/material-menu/training-materials',
    component: Layout,
    meta: {
      title: 'Material',
    },
    children: [
      {
        path: 'detail/:id',
        name: 'Details',
        component: () =>
          import(
            /* webpackChunkName: "profile-menu" */ '@/app/ui/views/MaterialMenu/TrainingMaterials/Details/index.vue'
          ),
      },
    ],
  },
  {
    path: '/material-menu/standar-operational',
    component: Layout,
    meta: {
      title: 'Material',
    },
    children: [
      {
        path: 'detail/:id',
        name: 'DetailQuick',
        component: () =>
          import(
            /* webpackChunkName: "profile-menu" */ '@/app/ui/views/MaterialMenu/QuickGuide/Details/index.vue'
          ),
      },
    ],
  },
]

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  base: process.env.VUE_APP_BASE_URL || 'cms',
  routes: [
    ...routeList,
    {
      path: '/404',
      component: Layout,
      children: [
        {
          path: 'index',
          name: '404',
          component: () =>
            import(
              /* webpackChunkName: "profile-menu" */ '@/app/ui/views/404/index.vue'
            ),
        },
      ],
    },
    {
      path: '/login',
      component: () =>
        import(
          /* webpackChunkName: "login" */ '@/app/ui/views/Login/index.vue'
        ),
      meta: { title: 'Login', hidden: true },
    },
  ],
})

router.beforeEach((to: any, from, next) => {
  if (to.name === '404') {
    next()
    return
  }
  const routing = routeList.filter((item) => {
    const meta = item.meta && item.meta.title
    return AuthModule.menu.map((data) => data.name).includes(meta)
  })
  const checkRole = (title: any) => {
    if (!title) {
      return false
    }

    const role = AuthModule.menu.map((item) => item.name).includes(title)
    if (title === 'Login') {
      return true
    }

    return role
  }

  if (!checkRole(to.matched.length ? to.matched[0].meta.title : ' ')) {
    next('/404/index')
    return
  }
  next()
})

export default router
